import { Component, OnInit, Input, TemplateRef } from '@angular/core';

import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'projection-for-location-mode',
    templateUrl: './projection-for-location-mode.shared.component.html',
})
export class ProjectionForLocationModeComponent implements OnInit {
    @Input() public venue: TemplateRef<any> = null;
    @Input() public location: TemplateRef<any> = null;

    public isModeSet$: Observable<boolean>;
    public isVenue$: Observable<boolean>;

    constructor(
        public controllers: Controllers,
    ) {
        this.isModeSet$ = this.controllers.appSettings.appLocationMode$()
            .pipe(
                map(mode => mode !== null),
            );

        this.isVenue$ = this.controllers.appSettings.appLocationMode$()
            .pipe(
                map(mode => mode === OLO.Enums.APP_MODE.VENUE)
            );
    }

    ngOnInit(): void { }
}
